import styled from 'styled-components';
import {
  Link as Redirect
} from "react-router-dom";

export const Container = styled.div`
  padding: 20px 10px;
  background-color: var(--primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  position:relative;
  & :after {
    content:'';
    flex: auto;
    justify-content: center;
  }
`;

export const Titulo = styled.span`
  padding-left: 10px;
  color: var(--white);
  text-align: left;
  font-size: 12px;
  text-decoration: none;

  @media(max-width: 600px) {
    font-size: 24px;
	}
`

export const LinkA = styled.a`
  text-decoration: none;
`

export const Img = styled.img`
  height: 50px;
  @media(max-width: 600px) {
    display: none;
	}
`

export const DivLogin = styled.div`
  display:flex;
  flex-direction: column;
`

export const DivSistema = styled.div`
  display:flex;
  align-items: center;
`

export const Link = styled(Redirect)`
  text-decoration: none;
  color: var(--white);
  display:  ${props => props.logado ? 'flex' : 'inherent'};
  align-items: center;
  font-size: 14px;
  text-align: center;

  ::visited {
    color: var(--white);
  }
`
